var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGhaithPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #00aa66 } \n\t\t.s1 { fill: #1c4246 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m304 314.7c0 26.5-21.5 48-48 48-26.5 0-48-21.5-48-48 0-26.5 21.5-48 48-48 26.5 0 48 21.5 48 48zm-64 0c0 8.8 7.2 16 16 16 8.8 0 16-7.2 16-16 0-8.8-7.2-16-16-16-8.8 0-16 7.2-16 16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m240 346.7v53.3c0 8.8 7.2 16 16 16 8.8 0 16-7.2 16-16v-53.3c0-8.8-7.2-16-16-16-8.8 0-16 7.2-16 16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m429.2 426.7c0 32.4-26.3 58.7-58.7 58.7h-229c-32.4 0-58.7-26.3-58.7-58.7v-170.7c0-32.4 26.3-58.7 58.7-58.7h229c32.4 0 58.7 26.3 58.7 58.7zm-58.7-197.4h-229c-14.8 0-26.7 12-26.7 26.7v170.7c0 14.8 12 26.7 26.7 26.7h229c14.8 0 26.7-12 26.7-26.7v-170.7c0-14.8-12-26.7-26.7-26.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m256.1 26.7c32.5 0 63.7 12.9 86.7 35.9 23 23 35.9 54.2 35.9 86.7v64c0 8.8-7.2 16-16 16h-213.3c-8.8 0-16-7.2-16-16v-64c0-32.5 12.9-63.7 35.9-86.7 23-23 54.2-35.9 86.7-35.9zm-0.1 32q0.03 0 0.05 0 0.02 0 0.05 0zm0.05 0c-23.98 0.01-47.06 9.61-64.05 26.6-17 17-26.6 40.1-26.6 64.1v48h181.3v-48c0-24-9.6-47.1-26.6-64.1-16.99-16.99-40.07-26.59-64.05-26.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhaithPassword);
export default __webpack_public_path__ + "static/media/GhaithPassword.b1476bec9bd02960a6e555b3c3c66951.svg";
export { ForwardRef as ReactComponent };